import { createContext, RefObject } from 'react'

import { LastEditedCellProps } from './types'

export type LastEditedCellContextValue = {
	lastEditedCell: LastEditedCellProps
	lastEditedCellRef: RefObject<HTMLTableCellElement>
}

export const LastEditedCellContext =
	createContext<LastEditedCellContextValue | null>(null)
